export default {
    meta: {
        title: '收入目标',
        isShowNav: true,
    },
};
